export const APP_NAME = "G O M";
export const APP_NOT_PERMISSION =
  "<h6><strong>Désolé !</strong> Vous n'avez pas la permission d'afficher ce contenu !</h6>";
export const ERROR_SOLVE_1 =
  "Veuilliez vérifier la stablilitée de votre connexion!";
export const ERROR_SOLVE_2 =
  "En cas de persistance, veuillez contacter l'administrateur";
export const ERROR_MESSAGE =
  "Désolé, un problème est survenue lors du traitement. \n 1- " +
  ERROR_SOLVE_1 +
  "\n 2- " +
  ERROR_SOLVE_2;

// export const RESPONSES_STATUS = {
//     NOT_FOUND: 'NOT_FOUND',
//
// }
